var render, staticRenderFns
import script from "./config-consumption-row-v2.vue?vue&type=script&lang=js"
export * from "./config-consumption-row-v2.vue?vue&type=script&lang=js"
import style0 from "./config-consumption-row-v2.vue?vue&type=style&index=0&id=47478e06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports